import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef, useMemo } from 'react';

import copy from 'copy-to-clipboard';
import { Copy } from 'lucide-react';
import { Button, InputGroup, DefaultTooltip, Input } from 'twyne-new.ui';

const propTypes = {
  value: PropTypes.any,
  children: PropTypes.any,
  label: PropTypes.any,
}

export default function URLView({ value, children, label, ...props }) {
  const [copied, setCopied] = useState(false)
  const inputRef = useRef(null)
  const groupRef = useRef(null)

  const handleCopyURL = e => {
    e.preventDefault()
    inputRef.current.select()

    if (value) {
      copy(value)
      setCopied(true)
    }
  }

  useEffect(() => {
    if (copied) {
      setTimeout(() => setCopied(false), 2000)
    }
  }, [copied, label])

  return <InputGroup tag={useTagRef('div', groupRef)}>
    {children}
    <Input
      {...props}
      readOnly
      value={value}
      ref={inputRef}
      className='border-l'
      placeholder='Token will be generated automatically after saving'
    />
    <DefaultTooltip content='Copied!' open={copied}>
      <DefaultTooltip content={!copied && value && `Click to copy the ${label}`} triggerProps={{ asChild: true }}>
        <Button onClick={handleCopyURL} variant='light' type='button' disabled={!value}>
          <Copy size={16} /> Copy {label}
        </Button>
      </DefaultTooltip>
    </DefaultTooltip>
  </InputGroup>
}

const useTagRef = (Tag, ref) => useMemo(() => props => <Tag {...props} ref={ref} />, [])

URLView.propTypes = propTypes
URLView.defaultProps = {
  label: 'url',
}
